module.exports = __webpack_public_path__ + "static/media/multiplication_levels.945e8630.png";